import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.measure)?_c('div',[_c(VIcon,{staticClass:"mt-n2",attrs:{"x-large":"","color":_vm.measure.mdiIconColor}},[_vm._v(_vm._s(_vm.measure.mdiIcon))]),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.measure.title))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }